<template>
    <iframe
      :src="src"
      title="OHIF Viewer"
      width="100%"
      height="100%"
      :style="iframeStyle"
      allowfullscreen
    />
  </template>
<script>
export default {
  name: 'OhifViewerIframe',
  props: {
    src: {
      type: String,
      required: true
    }
  },
  computed: {
    iframeStyle () {
      return {
        border: 'none',
        backgroundColor: '#14304c'
      }
    }
  },
  watch: {
    src (newSrc) {
    // console.log('src', newSrc)
    }
  }
}
</script>
